import { isNotNil } from '@lucidlink/tscore';
import { wrapper } from '@lucidlink/uicore';
import { getRouteObject, ProtectedRoute, } from '@lucidlink/workspacemanagement';
import { MobileHeaderLayout } from './components';
import { mobileMainRoutePredicate, mobileRegisterRoutePredicate, mobileVerifyEmailRouterPredicate, } from './services';
const mobileChildRoutesConfig = [
    {
        lazy: () => import('./pages/MobileHome/MobileHome'),
        path: '',
        wrappers: [
            wrapper(MobileHeaderLayout),
            wrapper(ProtectedRoute, { predicateFn: mobileMainRoutePredicate }),
        ],
    },
    {
        lazy: () => import('../features/auth/pages/MobileActivateAccount/MobileActivateAccount'),
        path: 'activate-account',
        wrappers: [wrapper(MobileHeaderLayout)],
    },
    {
        lazy: () => import('../features/auth/pages/MobileRegister/MobileRegister'),
        path: 'register',
        wrappers: [
            wrapper(MobileHeaderLayout),
            wrapper(ProtectedRoute, {
                predicateFn: mobileRegisterRoutePredicate,
            }),
        ],
    },
    {
        lazy: () => import('../features/auth/pages/MobileVerifyEmail'),
        path: 'verify-email',
        wrappers: [
            wrapper(MobileHeaderLayout),
            wrapper(ProtectedRoute, {
                predicateFn: mobileVerifyEmailRouterPredicate,
            }),
        ],
    },
    {
        lazy: () => import('../features/guest-links/pages/GuestLinkMobile'),
        path: 'g/:linkFormatVersion/:encodedFileData/:encodedEncryptedFileName',
        wrappers: [],
    },
    {
        lazy: () => import('../features/guest-links/pages/GuestLinkMobile'),
        path: 'guest/:guestLinkId/*',
        wrappers: [],
    },
];
export const mobileChildRouteObjects = mobileChildRoutesConfig.filter(isNotNil).map(getRouteObject);
